<template>
  <div id="app"  class="app-container">
    <router-view></router-view>
    <nav class="nav-menu" v-if="isLoggedIn">
      <el-menu
        :default-active="activeIndex"
        class="custom-menu"
        mode="horizontal"
        @select="handleMenuSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <!-- 动态生成菜单项 -->
        <template v-for="(link, index) in navLinks" :key="index">
          <!-- 父菜单项 -->
          <el-sub-menu
            v-if="link.children"
            :index="index.toString()"
          >
            <template #title>{{ link.text }}</template>
            <el-menu-item
              v-for="(child, childIndex) in link.children"
              :key="childIndex"
              :index="child.path"
            >
              {{ child.text }}
            </el-menu-item>
          </el-sub-menu>

          <!-- 普通菜单项 -->
          <el-menu-item
            v-else
            :index="link.path"
          >
            {{ link.text }}
          </el-menu-item>
        </template>
      </el-menu>
    </nav>
  </div>
</template>

<script>
export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  data() {
    return {
      activeIndex: '/', // 初始化当前激活路由
      navLinks: [
        {
         text: '个股期权',
          children: [
            { text: '个股香草', path: '/stock-search-form' },
            { text: '个股雪球', path: '/snowball-options' },
            { text: '无封顶气垫', path: '/uncapped-search-form' },
          ]
        },
        { text: '7095报价', path: '/risky-search-form' },
       // { text: '个股香草', path: '/stock-search-form' },
       // { text: '个股雪球', path: '/snowball-options' },
        { text: '个人中心', path: '/user-profile' }
      ]
    };
  },
  methods: {
    handleMenuSelect(index) {
      this.$router.push(index);
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
 .app-container {
  padding-bottom: 100px; /* 与菜单高度一致 */
}
 .nav-menu {
  background: #545c64;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.1);
  padding: 1rem 2rem;
  position: fixed; /* 固定定位 */
  bottom: 0;       /* 紧贴底部 */
  left: 0;
  width: 100%;     /* 全屏宽度 */

}
/* 确定菜单高度 */
.el-menu--horizontal {
  height: 30px; /* 根据实际调整 */
}
.el-menu--horizontal.el-menu{
    border: none;
}
.el-sub-menu.is-active .el-sub-menu__title{
    background-color: none;
}

</style>
